import script from "./SnackbarAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./SnackbarAlert.vue?vue&type=script&setup=true&lang=js"

import "./SnackbarAlert.vue?vue&type=style&index=0&id=df88e612&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df88e612"]])

export default __exports__